// import React, { useContext, useEffect, useState } from "react";
// import "./BudgetHead.css";
// import { apiurl } from "../../../../../path"; // add this import

// import Application from "../../../StateContext/Application.js";
// import {
//   Cancel32,
//   submit,
//   EditIcon,
//   DeleteIcon,
//   EditBlueBlue32,
// } from "../../../../../public/LoginImages/importimages";
// import Select from "react-select";
// // 27-10
// const getCurrentDateTime = () => {
//   const now = new Date();
//   const year = now.getFullYear();
//   const month = String(now.getMonth() + 1).padStart(2, "0");
//   const day = String(now.getDate()).padStart(2, "0");
//   const hours = String(now.getHours()).padStart(2, "0");
//   const minutes = String(now.getMinutes()).padStart(2, "0");
//   return `${year}-${month}-${day}T${hours}:${minutes}`;
// };
//   const BudgetHeadCreation = ({
//   isEdit = false,
//   projectDatainward = null,
//   onSuccess,
//   onCancel,
// }) => {
//   const operation = useContext(Application);
//   const { HeadCreation, GetProjectInfo, GetBudgetHeadInfo, GetObjectCodes } =
//     operation;

//   const [projectId, setProjectId] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [errors, setErrors] = useState({}); //09-10 eror msg
 
//   // form data for a single head
//   const [data, setData] = useState({
//     BudgetHeadName: "",
//     FinancialYear: "",
//     ObjectCode: "",
//     BudgetDetail: "",
//     CRC: "",
//     ProjectID: "",
//     ProjectName: "",
//     ProjectCost: "",
//     piu: "",
//     GRDate: null,
//     GRCopy:""
//   });

//   // store multiple heads before submit
//   const [headList, setHeadList] = useState([]);
//   const [headMode, setHeadMode] = useState("new"); // "new" | "existing"
//   const [allHeads, setAllHeads] = useState([]); // store from GetBudgetDetails
//   const [objectCodes, setObjectCodes] = useState([]); // State to store object codes
//   const [selectedProjects, setSelectedProjects] = useState([]);
//   const [editingIndex, setEditingIndex] = useState(null);

//   const GetBudgetDetails = async () => {
//     try {
//       let res = await GetBudgetHeadInfo("null", "all");
//       setAllHeads(res); // store all heads
//     } catch (err) {
//       console.log(err);
//     }
//   };
//   // Fetch object codes
//   // const FetchObjectCodes = async () => {
//   //   try {
//   //     let res = await GetObjectCodes(); // Fetch object codes from backend
//   //     setObjectCodes(res); // Store object codes in state
//   //   } catch (err) {
//   //     console.log(err);
//   //   }
//   // };
//   const FetchObjectCodes = async () => {
//     try {
//       const res = await GetObjectCodes();

//       console.log("Object Codes received in component:", res);

//       setObjectCodes(Array.isArray(res) ? res : []);
//     } catch (err) {
//       console.error("Error fetching object codes:", err);
//       setObjectCodes([]);
//     }
//   };

//   useEffect(() => {
//     GetBudgetDetails();
//     FetchObjectCodes();
//   }, []);

// // 09-10 error msg
//  const HandleChangeData = (e) => {
//   const { name, value } = e.target;
 
//   // if (name === "GRDate") {
//   //   setTimeout(() => {
//   //     e.target.blur();
//   //   }, 0);
 
//   //   const year = value.split("-")[0];
 
//   //   if (year.length > 4) {
//   //     return;
//   //   }
 
//   //   if (year && !/^\d{1,4}$/.test(year)) {
//   //     return;
//   //   }
//   // }
 
//   // 24-10
//   if (name === "GRDate" && value) {
//   const year = value.split("-")[0];

//   if (year.length > 4 || !/^\d{1,4}$/.test(year)) {
//     return;
//   }

//   // Block past date/time (same as Work Order). In edit mode, the saved
//   // GR Date is allowed to stay as it is.
//   const originalGRDate = projectDatainward?.GRDate
//     ? projectDatainward.GRDate.slice(0, 16)
//     : "";

//   if (value < getCurrentDateTime() && value !== originalGRDate) {
//     alert("Past date/time is not allowed");
//     return;
//   }
// }
//   if (name === "BudgetHeadName") {
//     if (!/^[A-Za-z\s]*$/.test(value)) {
//       return;
//     }
//   }
 
//   setData((prev) => ({
//     ...prev,
//     [name]: value,
//   }));
 
//   // Remove error as soon as user fills the field
//   setErrors((prev) => ({
//     ...prev,
//     [name]: "",
//   }));
// };
 


// // // 27-10
// const handleGRDateTimeChange = (e) => {
//   const input = e.target;
//   const value = input.value;

//   const prevDate = (data.GRDate || "").split("T")[0];
//   const newDate = (value || "").split("T")[0];

//   HandleChangeData({
//     target: { name: "GRDate", value },
//   });

//   if (!newDate) return;

//   // If the field was empty, compare against today (the picker opens on today)
//   const baseline = prevDate || getCurrentDateTime().split("T")[0];

//   const [py, pm, pd] = baseline.split("-").map(Number);
//   const [ny, nm, nd] = newDate.split("-").map(Number);

//   const monthChanged = py !== ny || pm !== nm;
//   const daysInNewMonth = new Date(ny, nm, 0).getDate();

//   // Month arrows keep the same day (or clamp it, e.g. 31 -> 30)
//   const isArrowNavigation =
//     monthChanged &&
//     (pd === nd || (nd === daysInNewMonth && pd > daysInNewMonth));

//   // Only the time was changed (same date as before)
//   const isTimeOnly = prevDate && newDate === prevDate;

//   // Close only when a date was actually clicked
//   if (!isArrowNavigation && !isTimeOnly) {
//     setTimeout(() => input.blur(), 0);
//   }
// };

//   const HeadIDFetchOperation = async (ID) => {
//     try {
//       let res1 = await GetProjectInfo(ID, "id");
//       let projectData = res1[0];

//       setData((prev) => ({
//         ...prev,
//         ProjectName: projectData.ProjectName,
//         ProjectID: projectData.ProjectId,
//         ProjectCost: projectData.ProjectCost,
//         piu: projectData.PIU,
//       }));
//     } catch (err) {
//       console.log(err);
//     }
//   };

//   // const handleAddHead = (e) => {
//   //   e.preventDefault();
//   //   if (!data.BudgetHeadName || !data.ProjectID || data.ProjectID === "null" || data.ObjectCode=="" || data.CRC=="" ) {
//   //     alert("Please fill all the fields");
//   //     return;
//   //   }
//   //   const project = projectId.find(p => p.ProjectId === data.ProjectID);

//   //   const newHead = {
//   //     ...data,
//   //     ProjectID: project.ProjectId,
//   //     ProjectName: project.ProjectName,
//   //     ProjectCost: project.ProjectCost,
//   //     piu: project.PIU
//   //   };

//   //   setHeadList(prev => [...prev, newHead]);

//   //   // clear only project when using existing head
//   //   if (headMode === "existing") {
//   //     setData(prev => ({
//   //       ...prev,
//   //       ProjectID: "null"
//   //     }));
//   //   } else {
//   //     // clear everything when creating a new head
//   //     setData(prev => ({
//   //       ...prev,
//   //       BudgetHeadName: "",
//   //       ObjectCode: "",
//   //       BudgetDetail: "",
//   //       CRC: "",
//   //       ProjectID: "null"
//   //     }));
//   //   }
//   // };

//   // const handleAddHead = (e) => {
//   //   e.preventDefault();
//   //   const trimmedName = data.BudgetHeadName.trim();
//   //   //const trimmedName = (data?.BudgetHeadName || "").trim();
//   //   const grFile = document.getElementById("GRCopy")?.files?.[0];
//   //   //const grFile = document.getElementById("GRCopy").files[0];
//   //   if (
//   //     !data.FinancialYear ||
//   //     data.FinancialYear === "null" ||
//   //     !trimmedName ||
//   //     !data.ObjectCode ||
//   //     !data.BudgetDetail ||
//   //     !data.CRC ||
//   //     !data.GRDate ||
//   //     (!isEdit && !grFile)
//   //   ) {
//   //     alert("Please fill all mandatory fields");
//   //     return;
//   //   }
//   //   // Check for duplicate in existing heads (fetched from backend)
//   //   const isDuplicateExisting = allHeads.some(
//   //     (head) => head.HeadName.toLowerCase() === trimmedName.toLowerCase(),
//   //   );

//   //   // Check for duplicate in current session added heads
//   //   const isDuplicateLocal = headList.some(
//   //     (head) => head.BudgetHeadName.toLowerCase() === trimmedName.toLowerCase(),
//   //   );

//   //   if (isDuplicateExisting || isDuplicateLocal) {
//   //     alert(
//   //       "This Budget Head Name already exists. Please use a different name.",
//   //     );
//   //     return;
//   //   }

//   //   // Create a new head object without project-related fields
//   //   const newHead = {
//   //     BudgetHeadName: trimmedName,
//   //     FinancialYear: data.FinancialYear,
//   //     ObjectCode: data.ObjectCode,
//   //     BudgetDetail: data.BudgetDetail,
//   //     CRC: data.CRC,
//   //     GRDate: data.GRDate,
//   //   };

//   //   // Add the new head to the head list
//   //   setHeadList((prev) => [...prev, newHead]);

//   //   // Clear the form fields
//   //   setData({
//   //     BudgetHeadName: "",
//   //     FinancialYear: "",
//   //     ObjectCode: "",
//   //     BudgetDetail: "",
//   //     CRC: "",
//   //     ProjectID: "",
//   //     ProjectName: "",
//   //     ProjectCost: "",
//   //     piu: "",
//   //     GRDate: "",
//   //   });
//   //   // Clear file input
//   //   document.getElementById("GRCopy").value = "";
//   // };
//   const handleAddHead = (e) => {
//     e.preventDefault();

// const trimmedName = data.BudgetHeadName.trim();
//     const fileInput = document.getElementById("GRCopy");
//  const grFile = fileInput?.files?.[0] || null;

//     // When editing, use the existing file if no new file is selected
//     const existingFile =
//       editingIndex !== null ? headList[editingIndex]?.GRCopy : null;

//     const finalGRFile = grFile || existingFile;

// // 09-10 error msg
//  const newErrors = {};
 
// if (!data.FinancialYear || data.FinancialYear === "null") {
//   newErrors.FinancialYear = "Financial Year is required";
// }
 
// if (!trimmedName) {
//   newErrors.BudgetHeadName = "Budget Head Name is required";
// }
 
// if (!data.ObjectCode) {
//   newErrors.ObjectCode = "Object Code is required";
// }
 
// if (!data.BudgetDetail?.trim()) {
//   newErrors.BudgetDetail = "Budget Head Details is required";
// }
 
// if (!data.CRC?.trim()) {
//   newErrors.CRC = "CRC is required";
// }
 
// if (!data.GRDate) {
//   newErrors.GRDate = "Budget GR Date is required";
// }
 
// if (!finalGRFile) {
//   newErrors.GRCopy = "Budget GR Copy is required";
// }
 
// if (Object.keys(newErrors).length > 0) {
//   setErrors(newErrors);
//   return;
// }
 
// setErrors({});
 
// //  ------------

//     // const trimmedName = data.BudgetHeadName.trim();

//     // const fileInput = document.getElementById("GRCopy");
    
//     // Validation
//     if (
//       !data.FinancialYear ||
//       data.FinancialYear === "null" ||
//       !trimmedName ||
//       !data.ObjectCode ||
//       !data.BudgetDetail ||
//       !data.CRC ||
//       !data.GRDate ||
//       !finalGRFile
//     ) {
//       alert("Please fill all mandatory fields");
//       return;
//     }

//     // Check duplicate in backend data
//     const isDuplicateExisting = allHeads.some(
//       (head) =>
//         head.HeadName?.toLowerCase() === trimmedName.toLowerCase() &&
//         // During edit, don't consider the same HeadID as duplicate
//         (!isEdit || head.HeadID !== projectDatainward?.HeadID),
//     );

//     // Check duplicate in current headList
//     const isDuplicateLocal = headList.some(
//       (head, index) =>
//         index !== editingIndex &&
//         head.BudgetHeadName?.toLowerCase() === trimmedName.toLowerCase(),
//     );

//     if (isDuplicateExisting || isDuplicateLocal) {
//       alert(
//         "This Budget Head Name already exists. Please use a different name.",
//       );
//       return;
//     }

//     const updatedHead = {
//       BudgetHeadName: trimmedName,
//       FinancialYear: data.FinancialYear,
//       ObjectCode: data.ObjectCode,
//       BudgetDetail: data.BudgetDetail,
//       CRC: data.CRC,
//       GRDate: data.GRDate,
//       GRCopy: finalGRFile,
//     };

//     // EDIT EXISTING ROW
//     if (editingIndex !== null) {
//       setHeadList((prev) =>
//         prev.map((item, index) =>
//           index === editingIndex ? updatedHead : item,
//         ),
//       );

//       setEditingIndex(null);
//     } else {
//       // ADD NEW ROW
//       setHeadList((prev) => [...prev, updatedHead]);
//     }

//     // Clear form
//     setData({
//       BudgetHeadName: "",
//       FinancialYear: "",
//       ObjectCode: "",
//       BudgetDetail: "",
//       CRC: "",
//       ProjectID: "",
//       ProjectName: "",
//       ProjectCost: "",
//       piu: "",
//       GRDate: "",
//     });

//     // Clear file input
//     if (fileInput) {
//       fileInput.value = "";
//     }
//   };
//   // const handleFinalSubmit = async () => {
//   //   if (headList.length === 0) {
//   //     alert("Please add at least one Budget Head");
//   //     return;
//   //   }
//   //   setLoading(true);
//   //   try {
//   //     const formData = new FormData();
//   //     formData.append("ProjectID", data.ProjectID);
//   //     formData.append("ProjectName", data.ProjectName);
//   //     formData.append("ProjectCost", data.ProjectCost);
//   //     formData.append("piu", data.piu);
//   //     formData.append("GRDate", data.GRDate);

//   //     let GRCopy = document.getElementById("GRCopy").files;
//   //     if (GRCopy.length > 0) formData.append("GRCopy", GRCopy[0]);

//   //     // append headList as JSON string
//   //     formData.append("headList", JSON.stringify(headList));

//   //     let result = await HeadCreation(formData);
//   //     if (result.message) {
//   //       alert(result.message);
//   //       window.location.reload();
//   //     }
//   //   } catch (err) {
//   //     console.log(err);
//   //   } finally {
//   //     setLoading(false);
//   //   }
//   // };

//   // final submit to backend

//   // const handleFinalSubmit = async () => {
//   //   if (headList.length === 0) {
//   //     alert("Please add at least one Budget Head");
//   //     return;
//   //   }
//   //   setLoading(true);
//   //   try {
//   //     const formData = new FormData();

//   //     // Append headList as a JSON string
//   //     formData.append("headList", JSON.stringify(headList));

//   //     let result = await HeadCreation(formData);
//   //     if (result.message) {
//   //       alert(result.message);
//   //       window.location.reload();
//   //     }
//   //   } catch (err) {
//   //     console.log(err);
//   //   } finally {
//   //     setLoading(false);
//   //   }
//   // };
//   // commented for fetching gr date and coopy 11/09
//   const handleFinalSubmit = async () => {
//   if (headList.length === 0) {
//     alert("Please add at least one Budget Head");
//     return;
//   }

//   setLoading(true);

//   try {
//     const formData = new FormData();

//     // Remove GRCopy from JSON because files
//     // must be appended separately
//     const headListForJSON = headList.map((head) => ({
//       BudgetHeadName: head.BudgetHeadName,
//       FinancialYear: head.FinancialYear,
//       ObjectCode: head.ObjectCode,
//       BudgetDetail: head.BudgetDetail,
//       CRC: head.CRC,
//       GRDate: head.GRDate,
//     }));

//     // Send head data
//     formData.append(
//       "headList",
//       JSON.stringify(headListForJSON)
//     );

//     // Send files separately
//     headList.forEach((head) => {
//       if (head.GRCopy instanceof File) {
//         formData.append("GRCopy", head.GRCopy);
//       }
//     });

//     // Debug
//     for (const pair of formData.entries()) {
//       console.log(
//         pair[0],
//         pair[1]
//       );
//     }

//     const result = await HeadCreation(formData);

//     if (result.message) {
//       alert(result.message);
//       window.location.reload();
//     }
//   } catch (err) {
//     console.log("Final Submit Error:", err);
//   } finally {
//     setLoading(false);
//   }
// };
//   const handleEditHead = (index) => {
//     const selectedHead = headList[index];

//     if (!selectedHead) return;

//     setData({
//       BudgetHeadName: selectedHead.BudgetHeadName || "",
//       FinancialYear: selectedHead.FinancialYear || "",
//       ObjectCode: selectedHead.ObjectCode || "",
//       BudgetDetail: selectedHead.BudgetDetail || "",
//       CRC: selectedHead.CRC || "",
//       ProjectID: "",
//       ProjectName: "",
//       ProjectCost: "",
//       piu: "",
//       GRDate: selectedHead.GRDate || "",
//         GRCopy: selectedHead?.GRCopy || "",
//     });

//     setEditingIndex(index);

//     // Scroll to form
//     window.scrollTo({
//       top: 0,
//       behavior: "smooth",
//     });
//   };
//   const handleDeleteHead = (index) => {
//     setHeadList((prev) => prev.filter((_, i) => i !== index));
//   };
//   const handleExistingHeadSelect = (id) => {
//     const selected = allHeads.find((h) => h.HeadID === parseInt(id));
//     if (selected) {
//       setData((prev) => ({
//         ...prev,
//         BudgetHeadName: selected.HeadName,
//         // ProjectID: selected.ProjectID,
//         ObjectCode: selected.objectCode,
//         BudgetDetail: selected.HeadDetails,
//         CRC: selected.CRC,
//       }));
//     }
//   };

//   useEffect(() => {
//     if (isEdit && projectDatainward) {
//       setData({
//         BudgetHeadName: projectDatainward.HeadName || "",
//         FinancialYear: projectDatainward.FinancialYear || "",
//         ObjectCode: projectDatainward.objectCode || "",
//         BudgetDetail: projectDatainward.HeadDetails || "",
//         CRC: projectDatainward.CRC || "",
//         ProjectID: projectDatainward.ProjectID || "",
//         ProjectName: projectDatainward.ProjectName || "",
//         ProjectCost: projectDatainward.ProjectCost || "",
//         piu: projectDatainward.PIU || "",
//         GRDate: projectDatainward.GRDate
//           ? projectDatainward.GRDate.slice(0, 16)
//           : "",
//             GRCopy: projectDatainward?.GRCopy || "",
//       });
//     }
//   }, [isEdit, projectDatainward]);
// //   const handleUpdate = async () => {
// //     try {
// //       const formData = new FormData();
// //       formData.append("type", "Update");
// //       formData.append("HeadID", projectDatainward.HeadID);
// //       formData.append("FinancialYear", data.FinancialYear);
// //       formData.append("BudgetHeadName", data.BudgetHeadName);
// //       formData.append("BudgetDetail", data.BudgetDetail);
// //       formData.append("CRC", data.CRC);
// //       formData.append("ObjectCode", data.ObjectCode);
// //       // const file = document.getElementById("GRCopy").files[0];
// //       // if (file) {
// //       //   formData.append("GRCopy", file);
// //       // }
// //       const file = document.getElementById("GRCopy").files[0];

// // if (file) {
// //   formData.append("GRCopy", file);
// // }
// //       let result = await HeadCreation(formData);
// //       if (result.message) {
// //         alert(result.message);
// //         if (onSuccess) onSuccess();
// //       }
// //     } catch (err) {
// //       console.log(err);
// //     }
// //   };


// const handleUpdate = async () => {
//   try {
//     const formData = new FormData();
//     formData.append("type", "Update");
//     formData.append("HeadID", projectDatainward.HeadID);
//     formData.append("FinancialYear", data.FinancialYear);
//     formData.append("BudgetHeadName", data.BudgetHeadName);
//     formData.append("BudgetDetail", data.BudgetDetail);
//     formData.append("CRC", data.CRC);
//     formData.append("ObjectCode", data.ObjectCode);
//     formData.append("GRDate", data.GRDate);   // ← this line was missing

//     const file = document.getElementById("GRCopy").files[0];
//     if (file) {
//       formData.append("GRCopy", file);
//     }

//     let result = await HeadCreation(formData);
//     if (result.message) {
//       alert(result.message);
//       if (onSuccess) onSuccess();
//     } else if (result.error) {
//       alert(result.error);   // ← surface backend errors too
//     }
//   } catch (err) {
//     console.log(err);
//     alert("Something went wrong while updating. Check console.");
//   }
// };

// // 05-10
// const handleCancel = () => {
//   const confirmCancel = window.confirm(
//     "Are you sure you want to cancel the form?"
//   );
 
//   if (!confirmCancel) {
//     return;
//   }
 
//   setData({
//     BudgetHeadName: "",
//     FinancialYear: "",
//     ObjectCode: "",
//     BudgetDetail: "",
//     CRC: "",
//     ProjectID: "",
//     ProjectName: "",
//     ProjectCost: "",
//     piu: "",
//     GRDate: null,
//   });
 
//   setHeadList([]);
//   setHeadMode("new");
 
//   // Clear file input
//   const fileInput = document.getElementById("GRCopy");
//   if (fileInput) {
//     fileInput.value = "";
//   }
 
//   alert("Form cancelled successfully.");
// };
 

//   return (
//     <div className="budget-head-page"
//   style={{
//     background: "#F3F6FC",
//     width: "auto",
//     maxHeight: "92vh",
//     overflowY: "auto",
//     scrollbarWidth: "none",
//     padding: "28px",
//     fontFamily: "Inter, sans-serif",
//     boxSizing: "border-box",
//     marginLeft:"40px",
//     marginRight:"40px"
//   }} >
//       <div
//         style={{
//           display: "flex",
//           alignItems: "center",
//           justifyContent: "flex-start",
//           background: "transparent",
//           padding: "0",
//           // marginRight: "20px",
//           // marginLeft: "-30px",
//           boxShadow: "none",
//           width: "100%",
//           marginBottom: "18px",
//         }}
//       >
//         <i
//           className="fa fa-user"
//           style={{
//             marginRight: "8px",
//             color: "#044c92",
//             fontSize: "18px",
//           }}
//         ></i>
//         <h5
//           style={{
//             margin: 0,
//             color: "black",
//             fontWeight: 700,
//             fontSize: "18px",
//             lineHeight: "1.2",
//           }}
//         >
//           Budget Head Creation
//         </h5>
//       </div>

//       {/* <h5
//          style={{ paddingRight :'10px',paddingBottom :'10px',marginBottom: "20px", fontWeight: "700", color: "black", textAlign: "left", width: "100%" }}
//         >
//           <img src={"/Bank-Master-32.png"} alt="Project Icon" style={{ marginRight: "5px", width: 28, height: 28 }} />
//          Budget Head Creation
//         </h5> */}
//       {/* {loading && (
//         <div
//           style={{
//             position: 'fixed', top: 0, left: 0, width: '100%', height: '100%',
//             background: 'rgba(255, 255, 255, 0.7)', backdropFilter: 'blur(4px)', zIndex: 9999,
//             display: 'flex', justifyContent: 'center', alignItems: 'center'
//           }}>
//           <div style={{
//             border: '6px solid #f3f3f3', borderTop: '6px solid #007bff',
//             borderRadius: '50%', width: '60px', height: '60px',
//             animation: 'spin 1s linear infinite'
//           }} />
//           <style>
//             {`@keyframes spin {0% { transform: rotate(0deg); }100% { transform: rotate(360deg); }}`}
//           </style>
//         </div>
//       )} */}

//       {/* <div className="col-12 ">
//         <h3 className='text-center fw-bold bg-light'>Budget Head Creation</h3>
//         <div className="col-12 m-auto my-5 budgetContainer">
//           <div className="m-auto budgetElement"> */}
//             <div style={{backgroundColor:"#ffffff",padding:"20px",borderRadius:"8px",   boxShadow:" 0 2px 8px rgba(0, 0, 0, .12)"}}>
//       <form onSubmit={(e) => e.preventDefault()} //14-10
//         style={{
//           // marginLeft: "20px",
//           display: "flex",
//           flexDirection: "column",
//           justifyContent: "center",
//           backgroundColor: "#eef1f6",
//           alignItems: "center",
//           width: "100%",
//           maxWidth: "1100px",
//           boxShadow: "none",
//           borderRadius: "8px",
//           padding: "0",
//           margin: "0 auto",
//           //  boxShadow:" 0 2px 8px rgba(0, 0, 0, .12)"
//         }}
//       >
//         {/* Financial Year      */}
//         <div
//          style={{
//             width: "100%",
//             maxWidth: "1200px",
//             backgroundColor: "#eef5fd",
//             boxShadow: "none",
//             borderRadius: "8px",
//             padding: "25px 28px 28px",
//             border: "1px solid #b8dcff",
//             boxSizing: "border-box",
//             // backgroundColor: "#eef1f6",
// border: "1px solid #eef5fd",
// borderRadius: "14px",
// boxShadow: "0 4px 18px rgba(35, 74, 120, 0.07)"}}
//         >
//           <div   style={{
//               display: "grid",
//               width: "100%",
//               // margin: "20px 0",
//               gridTemplateColumns: "1fr 1fr", // exactly 2 columns
//               columnGap: "20px",
//               rowGap: "14px",
//               boxSizing: "border-box",
//             }}
//           >
//           <div style={{ display: "flex", flexDirection: "column" }}>
//               <label  className="form-label"  style={{ fontWeight: "700",  marginBottom: "6px",  fontSize: "14px",  }}  > Financial Year </label>
//               <Select options={[
//                   { value: "2024-2025", label: "2024 - 2025" },
//                   { value: "2025-2026", label: "2025 - 2026" },
//                   { value: "2026-2027", label: "2026 - 2027" },
//                 ]}
//                 value={ data.FinancialYear   ? { value: data.FinancialYear,  label: data.FinancialYear.replace("-", " - "), } : null  }
//                 onChange={(selected) => HandleChangeData({
//                     target: {
//                       name: "FinancialYear",
//                       value: selected ? selected.value : "",
//                     },
//                   })
//                 }
//                 placeholder="Choose Financial Year"
//                 isSearchable
//                 isClearable
//                 styles={{
//                   control: (base) => ({
//                     ...base,
//                     minHeight: "40px",
//                     borderRadius: "10px",
//                     border: "1px solid #c7c0c0",
//                     fontSize: "12px",
//                   }),
//                 }}
//               />

//                 {errors.FinancialYear && (
//   <span
//     style={{
//       color: "#dc3545",
//       fontSize: "12px",
//       marginTop: "4px",
//     }}
//   >
//     {errors.FinancialYear}
//   </span>
// )}
//             </div>

//             {/* input fields (same as your code) */}
//             {/* Budget Head Name */}
//             {/* <div style={{ display: "flex", flexDirection: "column" }}>

//             <label className="form-label"
//               style={{ fontWeight: "700", marginBottom: "10px" }}>Head Type</label>
//             <select
//              style={{
//                 border: "1px solid #ccc",
//                 borderRadius: "5px",
//                 padding: "10px",
//                 width: "90%",
//               }}
//               value={headMode}
//               onChange={(e) => setHeadMode(e.target.value)}
//             >
//               <option value="new">Create New Head</option>
//               <option value="existing">Use Existing Head</option>
//             </select>
//           </div> */}

//             {headMode === "new" ? (
//               <div style={{ display: "flex", flexDirection: "column" }}>
//                 <label
//                   className="form-label"
//                   style={{
//                     fontWeight: "600",
//                     marginBottom: "6px",
//                     fontSize: "14px",
//                   }}
//                 >
//                   Budget Head Name
//                 </label>

//                 <input
//                   type="text"
//                   placeholder="Enter Budget Head Name"
//                   className="form-control py-2"
//                   style={{
//                     border: "1px solid #c7c0c0",
//                     borderRadius: "10px",
//                     padding: "7px 10px",
//                     width: "100%",
//                     height: "40px",
//                     boxSizing: "border-box",
//                     fontSize: "12px",
//                   }}
//                   name="BudgetHeadName"
//                   value={data.BudgetHeadName}
//                   onChange={HandleChangeData}
//                 />{errors.BudgetHeadName && (
//   <span
//     style={{
//       color: "#dc3545",
//       fontSize: "12px",
//       marginTop: "4px",
//     }}
//   >
//     {errors.BudgetHeadName}
//   </span>
// )}
//               </div>
//             ) : (
//               <div style={{ display: "flex", flexDirection: "column" }}>
//                 <label
//                   className="form-label"
//                   style={{
//                     fontWeight: "700",
//                     marginBottom: "6px",
//                     fontSize: "14px",
//                   }}
//                 >
//                   Select Existing Head
//                 </label>

//                 <select
//                   className="form-control py-2"
//                   style={{
//                     border: "1px solid #c7c0c0",
//                     borderRadius: "10px",
//                     padding: "7px 10px",
//                     width: "100%",
//                     height: "40px",
//                     boxSizing: "border-box",
//                     fontSize: "12px",
//                   }}
//                   onChange={(e) => handleExistingHeadSelect(e.target.value)}
//                 >
//                   <option value="">Choose Head</option>
//                   {allHeads.map((h) => (
//                     <option key={h.HeadID} value={h.HeadID}>
//                       {h.HeadName}
//                     </option>
//                   ))}
//                 </select>
//               </div>
//             )}
//             {/* Object Code */}
//             {/* <div  style={{ display: "flex", flexDirection: "column" }}>
//                 <div className="row">
//                   <div className="col-5"><label>Object Code</label></div>
//                   <div className="col-7">
//                     <input type="text" placeholder='Enter Object Code'
//                       className='form-control py-2' name='ObjectCode'
//                       value={data.ObjectCode} onChange={HandleChangeData} required/>
//                   </div>
//                 </div>
//               </div> */}
//             {/* Object Code Dropdown */}
//           <div style={{ display: "flex", flexDirection: "column" }}>
//                     <label
//                       className="form-label"
//                       style={{
//                         fontWeight: "700",
//                         marginBottom: "6px",
//                         fontSize: "14px",
//                       }}
//                     >
//                       Object Code
//                     </label>

//                     <Select
//                       options={objectCodes.map((code) => ({
//                         value: code,
//                         label: String(code) === "0" ? "NA" : String(code),
//                       }))}
//                       value={
//                         data.ObjectCode
//                           ? {
//                               value: data.ObjectCode,
//                               label:
//                                 String(data.ObjectCode) === "0"
//                                   ? "NA"
//                                   : String(data.ObjectCode),
//                             }
//                           : null
//                       }
//                       onChange={(selected) =>
//                         HandleChangeData({
//                           target: {
//                             name: "ObjectCode",
//                             value: selected ? selected.value : "",
//                           },
//                         })
//                       }
//                       placeholder="Choose Object Code"
//                       isSearchable
//                       isClearable
//                       noOptionsMessage={() => "No object code found"}
//                       styles={{
//                         control: (base) => ({
//                           ...base,
//                           minHeight: "40px",
//                           borderRadius: "10px",
//                           border: "1px solid #c7c0c0",
//                           fontSize: "12px",
//                         }),
//                       }}
//                     />{errors.ObjectCode && (
//   <span
//     style={{
//       color: "#dc3545",
//       fontSize: "12px",
//       marginTop: "4px",
//     }}
//   >
//     {errors.ObjectCode}
//   </span>
// )}
//                   </div>


//             {/* Details */}
//             <div style={{ display: "flex", flexDirection: "column" }}>
//               <label
//                 className="form-label"
//                 style={{
//                   fontWeight: "700",
//                   marginBottom: "6px",
//                   fontSize: "14px",
//                 }}
//               >
//                 Budget Head Details
//               </label>

//               <input
//                 type="text"
//                 placeholder="Enter Bugdet Head Details"
//                 style={{
//                   border: "1px solid #dacccc",
//                   borderRadius: "10px",
//                   padding: "7px 10px",
//                   width: "100%",
//                   height: "40px",
//                   boxSizing: "border-box",
//                   fontSize: "12px",
//                 }}
//                 name="BudgetDetail"
//                 value={data.BudgetDetail}
//                 onChange={HandleChangeData}
//                 //required
//               /> {errors.BudgetDetail && (
//   <span
//     style={{
//       color: "#dc3545",
//       fontSize: "12px",
//       marginTop: "4px",
//     }}
//   >
//     {errors.BudgetDetail}
//   </span>
// )}          </div>

//             {/* CRC */}
//             <div style={{ display: "flex", flexDirection: "column" }}>
//               <label
//                 className="form-label"
//                 style={{
//                   fontWeight: "700",
//                   marginBottom: "6px",
//                   fontSize: "14px",
//                 }}
//               >
//                 CRC
//               </label>

//               <input
//                 type="text"
//                 placeholder="Enter CRC"
//                 className="form-control py-2"
//                 style={{
//                   border: "1px solid #c7c0c0",
//                   borderRadius: "10px",
//                   padding: "7px 10px",
//                   width: "100%",
//                   height: "40px",
//                   boxSizing: "border-box",
//                   fontSize: "12px",
//                 }}
//                 name="CRC"
//                 value={data.CRC}
//                 onChange={HandleChangeData}
//                 //required
//               /> {errors.CRC && (
//   <span
//     style={{
//       color: "#dc3545",
//       fontSize: "12px",
//       marginTop: "4px",
//     }}
//   >
//     {errors.CRC}
//   </span>
// )}
 
//             </div>

//             {/* Project Dropdown */}
//             {/* <div  style={{ display: "flex", flexDirection: "column" }}> 
//               <div className="row"> 
//                 <div className="col-5 my-auto">
//                   <label>Project Name</label>
//                   </div> 
//                   <div className="col-7"> 
//                     <select name="ProjectID" value={data.ProjectID} className='py-2' onChange={(e) => { HandleChangeData(e); HeadIDFetchOperation(e.target.value) }}> 
//                       <option value="null">Choose Project</option> {projectId && projectId.map((val, index) => ( <option key={index} value={val.ProjectId}>{val.ProjectName}</option> ))} </select> 
//                       </div> 
//                 </div>
//               </div> */}

//             {/* Project Info */}
//             {/* <div  style={{ display: "flex", flexDirection: "column" }}>
//                 <div className="row">
//                   <div className="col-5"><label>Project Cost</label></div>
//                   <div className="col-7"><p>{data.ProjectCost || "--"}</p></div>
//                 </div>
//               </div>
//               <div  style={{ display: "flex", flexDirection: "column" }}>
//                 <div className="row">
//                   <div className="col-5"><label>PIU</label></div>
//                   <div className="col-7"><p>{data.piu || "--"}</p></div>
//                 </div>
//               </div> */}

//             {/* GR Date */}
//             <div style={{ display: "flex", flexDirection: "column" }}>
//               <label
//                 className="form-label"
//                 style={{
//                   fontWeight: "700",
//                   marginBottom: "6px",
//                   fontSize: "14px",
//                 }}
//               >
//                 Budget GR Date
//               </label>
// {/* 27-10 */}
//       <input
//   type="datetime-local"
//   className="form-control py-2"
//   name="GRDate"
//   value={(data.GRDate || "").slice(0, 16)}
//   min={getCurrentDateTime()}
//   max="9999-12-31T23:59"
//   onChange={handleGRDateTimeChange}
//   style={{
//     width: "100%",
//     height: "42px",
//     borderRadius: "10px",
//     border: "1px solid #c7c0c0",
//     fontSize: "12px",
//   }}
// />

//  {errors.GRDate && (
//   <span
//     style={{
//       color: "#dc3545",
//       fontSize: "12px",
//       marginTop: "4px",
//     }}
//   >
//     {errors.GRDate}
//   </span>
// )}
     
//             </div>

//             {/* GR Copy */}
//             <div style={{ display: "flex", flexDirection: "column" }}>
//               <label
//                 className="form-label"
//                 style={{
//                   fontWeight: "700",
//                   marginBottom: "6px",
//                   fontSize: "14px",
//                 }}
//               >
//                 {" "}
//                 Budget GR Copy
//               </label>
//               <input
//                 type="file"
//                 className="form-control py-2"
//                 style={{
//                   border: "1px solid #c7c0c0",
//                   borderRadius: "10px",
//                   padding: "7px 10px",
//                   width: "100%",
//                   height: "40px",
//                   boxSizing: "border-box",
//                   fontSize: "12px",
//                 }}
//                 id="GRCopy"
//                 //required={!isEdit}
//               />{errors.GRCopy && (
//   <span
//     style={{
//       color: "#dc3545",
//       fontSize: "12px",
//       marginTop: "4px",
//     }}
//   >
//     {errors.GRCopy}
//   </span>
// )}
 
//          {isEdit && data.GRCopy && typeof data.GRCopy === "string" && (
//   <div
//     style={{
//       marginTop: "8px",
//       fontSize: "12px",
//     }}
//   >
//     <span style={{ fontWeight: "600" }}>
//       Existing GR Copy:{" "}
//     </span>

//     <a
//       href={`${apiurl}/HeadDocsImages/${encodeURIComponent(data.GRCopy)}`}
//   target="_blank"
//   rel="noopener noreferrer"
//       style={{
//         color: "#0066cc",
//         textDecoration: "underline",
//       }}
//     >
//       {data.GRCopy}
//     </a>
//   </div>
// )}
//             </div>
//           </div>
//           {/* Add button */}
//           <div
//             style={{
//               display: "flex",
//               justifyContent: "center",
//               gap: "15px",
//               marginTop: "22px",
//               width: "100%",
//             }}
//           >
//             <button
//               style={{
//                 display: "flex",
//                 justifyContent: "center",
//                 alignItems: "center",
//                 borderRadius: "5px",
//                 width: "100px",
//                 height: "40px",
//                 backgroundColor: "#0066cc",
//                 border: "none",
//                 fontSize: "11px",
//                 color: "#fff",
//                 fontWeight: "600",
//                 cursor: "pointer",
//                 // boxShadow:" box-shadow: rgba(0, 0, 0, 0.07) 0px 1px 2px, rgba(0, 0, 0, 0.07) 0px 2px 4px, rgba(0, 0, 0, 0.07) 0px 4px 8px, rgba(0, 0, 0, 0.07) 0px 8px 16px, rgba(0, 0, 0, 0.07) 0px 16px 32px, rgba(0, 0, 0, 0.07) 0px 32px 64px",
//                 boxShadow:
//                   "rgba(0, 0, 0, 0.16) 0px 10px 36px 0px, rgba(0, 0, 0, 0.06) 0px 0px 0px 1px",
//               }}
//               onClick={isEdit ? handleUpdate : handleAddHead}
//             >
//               <img
//                 src={submit}
//                 style={{
//                   marginRight: "10px",
//                   width: "1.2rem",
//                   paddingBottom: "3px",
//                   fontSize: "15px",
//                 }}
//               />
//               {isEdit
//                 ? "Update"
//                 : editingIndex !== null
//                   ? "Update Head"
//                   : "Add Head"}
//             </button>

//             <button
//               type="button"
//               // onClick={() => {
//               //   // Clear all visible form fields
//               //   setData({
//               //     BudgetHeadName: "",
//               //     FinancialYear: "",
//               //     ObjectCode: "",
//               //     BudgetDetail: "",
//               //     CRC: "",
//               //     ProjectID: "",
//               //     ProjectName: "",
//               //     ProjectCost: "",
//               //     piu: "",
//               //     GRDate: "",
//               //     GRCopy:""
//               //   });
//               //   // Clear file input
//               //   const fileInput = document.getElementById("GRCopy");
//               //   if (fileInput) {
//               //     fileInput.value = "";
//               //   }
//               // }}

//               // 05-10
//                 onClick={handleCancel}
//               style={{
//                 display: "flex",
//                 justifyContent: "center",
//                 alignItems: "center",
//                 borderRadius: "5px",
//                 width: "100px",
//                 height: "40px",
//                 backgroundColor: "#f84b4b",
//                 border: "none",
//                 fontSize: "11px",
//                 color: "#fff",
//                 fontWeight: "600",
//                 cursor: "pointer",
//                 boxShadow:
//                   " box-shadow: rgba(0, 0, 0, 0.07) 0px 1px 2px, rgba(0, 0, 0, 0.07) 0px 2px 4px, rgba(0, 0, 0, 0.07) 0px 4px 8px, rgba(0, 0, 0, 0.07) 0px 8px 16px, rgba(0, 0, 0, 0.07) 0px 16px 32px, rgba(0, 0, 0, 0.07) 0px 32px 64px",
//               }}
//             >
//               <img
//                 src={Cancel32}
//                 style={{ marginRight: "10px", width: "1.2rem" }}
//               />
//               Cancel
//             </button>
//           </div>
//         </div>
//       </form>

//       {/* Show table of added heads */}
//       {headList.length > 0 && (
//         <div style={{ width: "100%",  maxWidth: "1100px", margin: "25px auto", backgroundColor: "#ffffff",borderRadius: "14px",overflow: "hidden", }}>
//           <table  style={{  width: "100%", margin: "0", padding: "0", borderCollapse: "separate", borderSpacing: "0", borderRadius: "14px", overflow: "hidden",  fontFamily: "Inter, sans-serif",fontSize: "12px", backgroundColor: "#ffffff",}}>
//             <thead>
//               <tr style={{ backgroundColor: "#e4ebfd",  color: "#111",fontSize: "13px", fontWeight: "600",textAlign: "center", whiteSpace: "nowrap", }}>
//                 <th style={{padding: "10px 12px",borderRight: "1px solid #d0d9ee", textAlign: "center",  }} >#</th> 
//                 <th style={{padding: "10px 12px",borderRight: "1px solid #d0d9ee", textAlign: "center", }}>Budget Head</th>
//                 <th style={{ padding: "10px 12px", borderRight: "1px solid #d0d9ee",textAlign: "center", }}> Object Code</th>
//                 <th style={{padding: "10px 12px", borderRight: "1px solid #d0d9ee", textAlign: "center", }}>Details</th>
//                 <th style={{ padding: "10px 12px", borderRight: "1px solid #d0d9ee", textAlign: "center",}}>CRC</th>
//                 {/* <th>Project</th> */}
//                 <th style={{ padding: "10px 12px", borderRight: "1px solid #d0d9ee", textAlign: "center", }}>Action</th>
//               </tr>
//             </thead>
//             <tbody>
//               {headList.map((item, index) => (
//                 <tr key={index}>
//                   <td>{index + 1}</td>
//                   <td>{item.BudgetHeadName}</td>
//                   <td>
//                     {String(item.ObjectCode) === "0" ? "NA" : item.ObjectCode}
//                   </td>
//                   <td>{item.BudgetDetail}</td>
//                   <td>{item.CRC}</td>
//                   {/* <td>{item.ProjectName}</td> */}
//                   <td>
//                     <div
//                       style={{
//                         display: "flex",
//                         gap: "8px",
//                         justifyContent: "center",
//                         alignItems: "center",
//                       }}
//                     >
//                       {/* EDIT */}
//                       <button
//                         type="button"
//                         onClick={() => handleEditHead(index)}
//                         style={{
//                           display: "flex",
//                           alignItems: "center",
//                           justifyContent: "center",
//                           gap: "5px",
//                           border: "none",
//                           borderRadius: "6px",
//                           backgroundColor: "#f8fafe",
//                           color: "#0d6efd",
//                           padding: "6px 10px",
//                           fontSize: "12px",
//                           fontWeight: "600",
//                           cursor: "pointer",
//                           border:"1px solid #0d6efd"
//                         }}
//                       >
//                         <img
//                           src={EditIcon}
//                           alt="Edit"
//                           style={{
//                             width: "16px",
//                             height: "16px",
//                           }}
//                         />
//                         Edit
//                       </button>

//                       {/* DELETE */}
//                       <button
//                         type="button"
//                         onClick={() => handleDeleteHead(index)}
//                         style={{
//                           display: "flex",
//                           alignItems: "center",
//                           justifyContent: "center",
//                           gap: "5px",
//                           border: "none",
//                           borderRadius: "6px",
//                           backgroundColor: "#faf4f5",
//                           color: "#dc3545",
//                           padding: "6px 12px",
//                           fontSize: "12px",
//                           fontWeight: "600",
//                           cursor: "pointer",
//                           border:"1px solid #dc3545 "
//                         }}
//                       >
//                         <img
//                           src={DeleteIcon}
//                           alt="Delete"
//                           style={{
//                             width: "16px",
//                             height: "16px",
//                           }}
//                         />
//                         Delete
//                       </button>
//                     </div>
//                   </td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//           {/* <button className="btn btn-primary mt-2" onClick={handleFinalSubmit}>
//             Final Submit
//           </button> */}
//             <div
//   style={{
//     width: "100%",
//     display: "flex",
//     justifyContent: "center",
//     alignItems: "center",
//     marginTop: "20px",
//   }}
// >
//           {/* <button style={{  width: "120px", height: "40px", border: "none",  borderRadius: "10px", backgroundColor: "#39b54a", color: "#ffffff", fontWeight: "700",justifyContent:"center", textAlign:'center', marginTop:"20px", cursor: "pointer", }} onClick={handleFinalSubmit}>
//            <img src={submit} alt="Submit" style={{   width: "16px", marginRight: "8px",  }} />  
//            Final Submit
//           </button> */}
//           {/* 30-09 add loader */}
//           <button
//   type="button"
//   style={{
//     width: "120px",
//     height: "40px",
//     border: "none",
//     borderRadius: "10px",
//     backgroundColor: loading ? "#7acb84" : "#39b54a",
//     color: "#ffffff",
//     fontWeight: "700",
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "center",
//     gap: "8px",
//     marginTop: "20px",
//     cursor: loading ? "not-allowed" : "pointer",
//   }}
//   onClick={handleFinalSubmit}
//   disabled={loading}
// >
//   {loading ? (
//     <>
//       <span
//         style={{
//           width: "16px",
//           height: "16px",
//           border: "2px solid rgba(255,255,255,0.4)",
//           borderTop: "2px solid #ffffff",
//           borderRadius: "50%",
//           animation: "spin 0.8s linear infinite",
//         }}
//       />
//       Submitting...
//     </>
//   ) : (
//     <>
//       <img
//         src={submit}
//         alt="Submit"
//         style={{
//           width: "16px",
//           marginRight: "2px",
//         }}
//       />
//       Final Submit
//     </>
//   )}
// </button>
 
//           </div>
 
//         </div>
//       )}
//     </div>
//     //     </div>
//     //   </div>
//     // </div>
//   );
// };

// export default BudgetHeadCreation;


import React, { useContext, useEffect, useState } from "react";
import "./BudgetHead.css";
import { apiurl } from "../../../../../path"; // add this import

import Application from "../../../StateContext/Application.js";
// 27-10
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {
  Cancel32,
  submit,
  EditIcon,
  DeleteIcon,
  EditBlueBlue32,
} from "../../../../../public/LoginImages/importimages";
import Select from "react-select";
//const BudgetHeadCreation = () => {
// 27-10
const getCurrentDateTime = () => {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, "0");
  const day = String(now.getDate()).padStart(2, "0");
  const hours = String(now.getHours()).padStart(2, "0");
  const minutes = String(now.getMinutes()).padStart(2, "0");
  return `${year}-${month}-${day}T${hours}:${minutes}`;
};
  const BudgetHeadCreation = ({
  isEdit = false,
  projectDatainward = null,
  onSuccess,
  onCancel,
}) => {
  const operation = useContext(Application);
  const { HeadCreation, GetProjectInfo, GetBudgetHeadInfo, GetObjectCodes } =
    operation;

  const [projectId, setProjectId] = useState([]);
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({}); //09-10 eror msg
const [newGRFile, setNewGRFile] = useState(null);   // ← ADD//16-10 for gr copy fetch
  // form data for a single head
  const [data, setData] = useState({
    BudgetHeadName: "",
    FinancialYear: "",
    ObjectCode: "",
    BudgetDetail: "",
    CRC: "",
    ProjectID: "",
    ProjectName: "",
    ProjectCost: "",
    piu: "",
    GRDate: null,
    GRCopy:""
  });

  // store multiple heads before submit
  const [headList, setHeadList] = useState([]);
  const [headMode, setHeadMode] = useState("new"); // "new" | "existing"
  const [allHeads, setAllHeads] = useState([]); // store from GetBudgetDetails
  const [objectCodes, setObjectCodes] = useState([]); // State to store object codes
  const [selectedProjects, setSelectedProjects] = useState([]);
  const [editingIndex, setEditingIndex] = useState(null);

  const GetBudgetDetails = async () => {
    try {
      let res = await GetBudgetHeadInfo("null", "all");
      setAllHeads(res); // store all heads
    } catch (err) {
      console.log(err);
    }
  };
  // Fetch object codes
 
  const FetchObjectCodes = async () => {
    try {
      const res = await GetObjectCodes();

      console.log("Object Codes received in component:", res);

      setObjectCodes(Array.isArray(res) ? res : []);
    } catch (err) {
      console.error("Error fetching object codes:", err);
      setObjectCodes([]);
    }
  };

  useEffect(() => {
    GetBudgetDetails();
    FetchObjectCodes();
  }, []);

const handleGRDatePart = (part, val) => {
  const [currentDate = "", currentTime = ""] = (data.GRDate || "").split("T");

  const nextDate = part === "date" ? val : currentDate;
  // Default the time to "now" so picking today's date is not treated as a past time
  const nextTime =
    part === "time" ? val : currentTime || getCurrentDateTime().split("T")[1];

  if (!nextDate) {
    HandleChangeData({ target: { name: "GRDate", value: "" } });
    return;
  }

  HandleChangeData({
    target: { name: "GRDate", value: `${nextDate}T${nextTime || "00:00"}` },
  });
};
// 09-10 error msg
 const HandleChangeData = (e) => {
  const { name, value } = e.target;
 
  // 27-10

if (name === "GRDate" && value) {
  const year = value.split("-")[0];

  if (year.length > 4 || !/^\d{1,4}$/.test(year)) {
    return;
  }

  const originalGRDate = projectDatainward?.GRDate
    ? projectDatainward.GRDate.slice(0, 16)
    : "";

  // Allow the original saved date/time while editing.
  if (
    value < getCurrentDateTime() &&
    value !== originalGRDate
  ) {
    alert("Past date/time is not allowed");
    return;
  }
}

  if (name === "BudgetHeadName") {
    if (!/^[A-Za-z\s]*$/.test(value)) {
      return;
    }
  }
 
  setData((prev) => ({
    ...prev,
    [name]: value,
  }));
 
  // Remove error as soon as user fills the field
  setErrors((prev) => ({
    ...prev,
    [name]: "",
  }));
};
 

// // 27-10
const handleGRDateTimeChange = (e) => {
  const input = e.target;
  const value = input.value;

  const prevDate = (data.GRDate || "").split("T")[0];
  const newDate = (value || "").split("T")[0];

  HandleChangeData({
    target: { name: "GRDate", value },
  });

  if (!newDate) return;

  // If the field was empty, compare against today (the picker opens on today)
  const baseline = prevDate || getCurrentDateTime().split("T")[0];

  const [py, pm, pd] = baseline.split("-").map(Number);
  const [ny, nm, nd] = newDate.split("-").map(Number);

  const monthChanged = py !== ny || pm !== nm;
  const daysInNewMonth = new Date(ny, nm, 0).getDate();

  // Month arrows keep the same day (or clamp it, e.g. 31 -> 30)
  const isArrowNavigation =
    monthChanged &&
    (pd === nd || (nd === daysInNewMonth && pd > daysInNewMonth));

  // Only the time was changed (same date as before)
  const isTimeOnly = prevDate && newDate === prevDate;

  // Close only when a date was actually clicked
  if (!isArrowNavigation && !isTimeOnly) {
    setTimeout(() => input.blur(), 0);
  }
};
  const HeadIDFetchOperation = async (ID) => {
    try {
      let res1 = await GetProjectInfo(ID, "id");
      let projectData = res1[0];

      setData((prev) => ({
        ...prev,
        ProjectName: projectData.ProjectName,
        ProjectID: projectData.ProjectId,
        ProjectCost: projectData.ProjectCost,
        piu: projectData.PIU,
      }));
    } catch (err) {
      console.log(err);
    }
  };

  const handleAddHead = (e) => {
    e.preventDefault();

const trimmedName = data.BudgetHeadName.trim();
    const fileInput = document.getElementById("GRCopy");
 const grFile = fileInput?.files?.[0] || null;

    // When editing, use the existing file if no new file is selected
    const existingFile =
      editingIndex !== null ? headList[editingIndex]?.GRCopy : null;

    const finalGRFile = grFile || existingFile;

// 09-10 error msg
 const newErrors = {};
 
if (!data.FinancialYear || data.FinancialYear === "null") {
  newErrors.FinancialYear = "Financial Year is required";
}
 
if (!trimmedName) {
  newErrors.BudgetHeadName = "Budget Head Name is required";
}
 
if (!data.ObjectCode) {
  newErrors.ObjectCode = "Object Code is required";
}
 
if (!data.BudgetDetail?.trim()) {
  newErrors.BudgetDetail = "Budget Head Details is required";
}
 
if (!data.CRC?.trim()) {
  newErrors.CRC = "CRC is required";
}
 
if (!data.GRDate) {
  newErrors.GRDate = "Budget GR Date is required";
}
 
if (!finalGRFile) {
  newErrors.GRCopy = "Budget GR Copy is required";
}
 
if (Object.keys(newErrors).length > 0) {
  setErrors(newErrors);
  return;
}
 
setErrors({});
 
//  ------------

    // const trimmedName = data.BudgetHeadName.trim();

    // const fileInput = document.getElementById("GRCopy");
    
    // Validation
    if (
      !data.FinancialYear ||
      data.FinancialYear === "null" ||
      !trimmedName ||
      !data.ObjectCode ||
      !data.BudgetDetail ||
      !data.CRC ||
      !data.GRDate ||
      !finalGRFile
    ) {
      alert("Please fill all mandatory fields");
      return;
    }

    // Check duplicate in backend data
    const isDuplicateExisting = allHeads.some(
      (head) =>
        head.HeadName?.toLowerCase() === trimmedName.toLowerCase() &&
        // During edit, don't consider the same HeadID as duplicate
        (!isEdit || head.HeadID !== projectDatainward?.HeadID),
    );

    // Check duplicate in current headList
    const isDuplicateLocal = headList.some(
      (head, index) =>
        index !== editingIndex &&
        head.BudgetHeadName?.toLowerCase() === trimmedName.toLowerCase(),
    );

    if (isDuplicateExisting || isDuplicateLocal) {
      alert(
        "This Budget Head Name already exists. Please use a different name.",
      );
      return;
    }

    const updatedHead = {
      BudgetHeadName: trimmedName,
      FinancialYear: data.FinancialYear,
      ObjectCode: data.ObjectCode,
      BudgetDetail: data.BudgetDetail,
      CRC: data.CRC,
      GRDate: data.GRDate,
      GRCopy: finalGRFile,
    };

    // EDIT EXISTING ROW
    if (editingIndex !== null) {
      setHeadList((prev) =>
        prev.map((item, index) =>
          index === editingIndex ? updatedHead : item,
        ),
      );

      setEditingIndex(null);
    } else {
      // ADD NEW ROW
      setHeadList((prev) => [...prev, updatedHead]);
    }

    // Clear form
    setData({
      BudgetHeadName: "",
      FinancialYear: "",
      ObjectCode: "",
      BudgetDetail: "",
      CRC: "",
      ProjectID: "",
      ProjectName: "",
      ProjectCost: "",
      piu: "",
      GRDate: "",
    });

    // Clear file input
    if (fileInput) {
      fileInput.value = "";
    }
  };
  
  // commented for fetching gr date and coopy 11/09
  const handleFinalSubmit = async () => {
  if (headList.length === 0) {
    alert("Please add at least one Budget Head");
    return;
  }

  setLoading(true);

  try {
    const formData = new FormData();

    // Remove GRCopy from JSON because files
    // must be appended separately
    const headListForJSON = headList.map((head) => ({
      BudgetHeadName: head.BudgetHeadName,
      FinancialYear: head.FinancialYear,
      ObjectCode: head.ObjectCode,
      BudgetDetail: head.BudgetDetail,
      CRC: head.CRC,
      GRDate: head.GRDate,
    }));

    // Send head data
    formData.append(
      "headList",
      JSON.stringify(headListForJSON)
    );

    // Send files separately
    headList.forEach((head) => {
      if (head.GRCopy instanceof File) {
        formData.append("GRCopy", head.GRCopy);
      }
    });

    // Debug
    for (const pair of formData.entries()) {
      console.log(
        pair[0],
        pair[1]
      );
    }

    const result = await HeadCreation(formData);

    if (result.message) {
      alert(result.message);
      window.location.reload();
    }
  } catch (err) {
    console.log("Final Submit Error:", err);
  } finally {
    setLoading(false);
  }
};
  const handleEditHead = (index) => {
    const selectedHead = headList[index];

    if (!selectedHead) return;

    setData({
      BudgetHeadName: selectedHead.BudgetHeadName || "",
      FinancialYear: selectedHead.FinancialYear || "",
      ObjectCode: selectedHead.ObjectCode || "",
      BudgetDetail: selectedHead.BudgetDetail || "",
      CRC: selectedHead.CRC || "",
      ProjectID: "",
      ProjectName: "",
      ProjectCost: "",
      piu: "",
      GRDate: selectedHead.GRDate || "",
        GRCopy: selectedHead?.GRCopy || "",
    });

    setEditingIndex(index);

    // Scroll to form
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };
  const handleDeleteHead = (index) => {
    setHeadList((prev) => prev.filter((_, i) => i !== index));
  };
  const handleExistingHeadSelect = (id) => {
    const selected = allHeads.find((h) => h.HeadID === parseInt(id));
    if (selected) {
      setData((prev) => ({
        ...prev,
        BudgetHeadName: selected.HeadName,
        // ProjectID: selected.ProjectID,
        ObjectCode: selected.objectCode,
        BudgetDetail: selected.HeadDetails,
        CRC: selected.CRC,
      }));
    }
  };

  useEffect(() => {
    if (isEdit && projectDatainward) {
      setData({
        BudgetHeadName: projectDatainward.HeadName || "",
        FinancialYear: projectDatainward.FinancialYear || "",
        ObjectCode: projectDatainward.objectCode || "",
        BudgetDetail: projectDatainward.HeadDetails || "",
        CRC: projectDatainward.CRC || "",
        ProjectID: projectDatainward.ProjectID || "",
        ProjectName: projectDatainward.ProjectName || "",
        ProjectCost: projectDatainward.ProjectCost || "",
        piu: projectDatainward.PIU || "",
        GRDate: projectDatainward.GRDate
          ? projectDatainward.GRDate.slice(0, 16)
          : "",
            GRCopy: projectDatainward?.GRCopy || "",
      });
    }
  }, [isEdit, projectDatainward]);

// 16-10

const handleUpdate = async (e) => {
    if (e) e.preventDefault(); //16-10
  try {
    if (!projectDatainward?.HeadID) {
      alert("HeadID is missing. Please reopen Edit from Outward List.");
      console.error("projectDatainward:", projectDatainward);
      return;
    }

    const formData = new FormData();

    formData.append("type", "Update");
    formData.append("HeadID", String(projectDatainward.HeadID));
    formData.append("FinancialYear", data.FinancialYear || "");
    formData.append("BudgetHeadName", data.BudgetHeadName || "");
    formData.append("BudgetDetail", data.BudgetDetail || "");
    formData.append("CRC", data.CRC || "");
    formData.append("ObjectCode", data.ObjectCode || "");
    formData.append("GRDate", data.GRDate || "");

    if (newGRFile) {
      formData.append("GRCopy", newGRFile);
    }

    console.log("Updating budget head:", {
      HeadID: projectDatainward.HeadID,
      fields: Object.fromEntries(
        [...formData.entries()].filter(
          ([key, value]) => key !== "GRCopy" || typeof value === "string"
        )
      ),
      newGRFile: newGRFile?.name || "No new file selected",
    });

    const result = await HeadCreation(formData);
    console.log("Budget head update response:", result);

    if (result?.error) {
      alert(result.error);
      return;
    }

    if (!result?.message) {
      alert("Update response was not received correctly. Check the console.");
      return;
    }

    if (result.GRCopy) {
      setData((prev) => ({
        ...prev,
        GRCopy: result.GRCopy,
      }));
    }

    setNewGRFile(null);

    const fileInput = document.getElementById("GRCopy");
    if (fileInput) fileInput.value = "";

    alert(result.message);

    if (onSuccess) {
      onSuccess();
    }
  } catch (err) {
    console.error("Budget head update error:", err);
    console.error("Backend response:", err.response?.data);

    alert(
      err.response?.data?.error ||
      "Update failed. Check the browser console and backend terminal."
    );
  }
};

// 05-10
const handleCancel = () => {
  const confirmCancel = window.confirm(
    "Are you sure you want to cancel the form?"
  );
 
  if (!confirmCancel) {
    return;
  }
 
  setData({
    BudgetHeadName: "",
    FinancialYear: "",
    ObjectCode: "",
    BudgetDetail: "",
    CRC: "",
    ProjectID: "",
    ProjectName: "",
    ProjectCost: "",
    piu: "",
    GRDate: null,
  });
 
  setHeadList([]);
  setNewGRFile(null);//16-10
  setHeadMode("new");
 
  // Clear file input
  const fileInput = document.getElementById("GRCopy");
  if (fileInput) {
    fileInput.value = "";
  }
 
  alert("Form cancelled successfully.");
};
 
const formatGRDateTime = (date) => {
  if (!date) return "";

  const pad = (num) => String(num).padStart(2, "0");

  return (
    `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}` +
    `T${pad(date.getHours())}:${pad(date.getMinutes())}`
  );
};

  return (
    <div
       className="budget-head-page"
  style={{
    background: "#F3F6FC",
    width: "auto",
    maxHeight: "89vh",
    height:"89vh",
    overflowY: "auto",
    scrollbarWidth: "none",
    padding: "28px",
    fontFamily: "Inter, sans-serif",
    boxSizing: "border-box",
    marginLeft:"40px",
    marginRight:"40px",
    marginTop:"17px"
  }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-start",
          background: "transparent",
          padding: "0",
          boxShadow: "none",
          width: "100%",
          marginBottom: "18px",
        }}
      >
        <i
          className="fa fa-user"
          style={{
            marginRight: "8px",
            color: "#044c92",
            fontSize: "18px",
          }}
        ></i>
        <h5
          style={{
            margin: 0,
            color: "black",
            fontWeight: 700,
            fontSize: "18px",
            lineHeight: "1.2",
          }}
        >
          Budget Head Creation
        </h5>
      </div>


      

     <div style={{backgroundColor:"#ffffff",padding:"20px",borderRadius:"8px",   boxShadow:" 0 2px 8px rgba(0, 0, 0, .12)"}}>
      <form
       onSubmit={(e) => e.preventDefault()} //14-10
        style={{
          // marginLeft: "20px",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          backgroundColor: "#eef1f6",
          alignItems: "center",
          width: "100%",
          maxWidth: "1100px",
          boxShadow: "none",
          borderRadius: "8px",
          padding: "0",
          margin: "0 auto",
          //  boxShadow:" 0 2px 8px rgba(0, 0, 0, .12)"
        }}
      >
        {/* Financial Year      */}
        <div
          style={{
            width: "100%",
            maxWidth: "1200px",
            backgroundColor: "#eef5fd",
            boxShadow: "none",
            borderRadius: "8px",
            padding: "25px 28px 28px",
            border: "1px solid #b8dcff",
            boxSizing: "border-box",
            // backgroundColor: "#eef1f6",
border: "1px solid #eef5fd",
borderRadius: "14px",
boxShadow: "0 4px 18px rgba(35, 74, 120, 0.07)",
          }}
        >
          <div   style={{
              display: "grid",
              width: "100%",
              // margin: "20px 0",
              gridTemplateColumns: "1fr 1fr", // exactly 2 columns
              columnGap: "20px",
              rowGap: "14px",
              boxSizing: "border-box",
            }}
          >
          <div style={{ display: "flex", flexDirection: "column" }}>
              <label  className="form-label"  style={{ fontWeight: "700",  marginBottom: "6px",  fontSize: "14px",  }}  > Financial Year </label>
              <Select options={[
                  { value: "2024-2025", label: "2024 - 2025" },
                  { value: "2025-2026", label: "2025 - 2026" },
                  { value: "2026-2027", label: "2026 - 2027" },
                ]}
                value={ data.FinancialYear   ? { value: data.FinancialYear,  label: data.FinancialYear.replace("-", " - "), } : null  }
                onChange={(selected) => HandleChangeData({
                    target: {
                      name: "FinancialYear",
                      value: selected ? selected.value : "",
                    },
                  })
                }
                placeholder="Choose Financial Year"
                isSearchable
                isClearable
                styles={{
                  control: (base) => ({
                    ...base,
                    minHeight: "40px",
                    borderRadius: "10px",
                    border: "1px solid #c7c0c0",
                    fontSize: "12px",
                  }),
                }}
              />

                {errors.FinancialYear && (
  <span
    style={{
      color: "#dc3545",
      fontSize: "12px",
      marginTop: "4px",
    }}
  >
    {errors.FinancialYear}
  </span>
)}
            </div>


            {headMode === "new" ? (
              <div style={{ display: "flex", flexDirection: "column" }}>
                <label
                  className="form-label"
                  style={{
                    fontWeight: "600",
                    marginBottom: "6px",
                    fontSize: "14px",
                  }}
                >
                  Budget Head Name
                </label>

                <input
                  type="text"
                  placeholder="Enter Budget Head Name"
                  className="form-control py-2"
                  style={{
                    border: "1px solid #c7c0c0",
                    borderRadius: "10px",
                    padding: "7px 10px",
                    width: "100%",
                    height: "40px",
                    boxSizing: "border-box",
                    fontSize: "12px",
                  }}
                  name="BudgetHeadName"
                  value={data.BudgetHeadName}
                  onChange={HandleChangeData}
                />{errors.BudgetHeadName && (
  <span
    style={{
      color: "#dc3545",
      fontSize: "12px",
      marginTop: "4px",
    }}
  >
    {errors.BudgetHeadName}
  </span>
)}
              </div>
            ) : (
              <div style={{ display: "flex", flexDirection: "column" }}>
                <label
                  className="form-label"
                  style={{
                    fontWeight: "700",
                    marginBottom: "6px",
                    fontSize: "14px",
                  }}
                >
                  Select Existing Head
                </label>

                <select
                  className="form-control py-2"
                  style={{
                    border: "1px solid #c7c0c0",
                    borderRadius: "10px",
                    padding: "7px 10px",
                    width: "100%",
                    height: "40px",
                    boxSizing: "border-box",
                    fontSize: "12px",
                  }}
                  onChange={(e) => handleExistingHeadSelect(e.target.value)}
                >
                  <option value="">Choose Head</option>
                  {allHeads.map((h) => (
                    <option key={h.HeadID} value={h.HeadID}>
                      {h.HeadName}
                    </option>
                  ))}
                </select>
              </div>
            )}
            {/* Object Code */}
           
            {/* Object Code Dropdown */}
          <div style={{ display: "flex", flexDirection: "column" }}>
                    <label
                      className="form-label"
                      style={{
                        fontWeight: "700",
                        marginBottom: "6px",
                        fontSize: "14px",
                      }}
                    >
                      Object Code
                    </label>

                    <Select
                      options={objectCodes.map((code) => ({
                        value: code,
                        label: String(code) === "0" ? "NA" : String(code),
                      }))}
                      value={
                        data.ObjectCode
                          ? {
                              value: data.ObjectCode,
                              label:
                                String(data.ObjectCode) === "0"
                                  ? "NA"
                                  : String(data.ObjectCode),
                            }
                          : null
                      }
                      onChange={(selected) =>
                        HandleChangeData({
                          target: {
                            name: "ObjectCode",
                            value: selected ? selected.value : "",
                          },
                        })
                      }
                      placeholder="Choose Object Code"
                      isSearchable
                      isClearable
                      noOptionsMessage={() => "No object code found"}
                      styles={{
                        control: (base) => ({
                          ...base,
                          minHeight: "40px",
                          borderRadius: "10px",
                          border: "1px solid #c7c0c0",
                          fontSize: "12px",
                        }),
                      }}
                    />{errors.ObjectCode && (
  <span
    style={{
      color: "#dc3545",
      fontSize: "12px",
      marginTop: "4px",
    }}
  >
    {errors.ObjectCode}
  </span>
)}
                  </div>


            {/* Details */}
            <div style={{ display: "flex", flexDirection: "column" }}>
              <label
                className="form-label"
                style={{
                  fontWeight: "700",
                  marginBottom: "6px",
                  fontSize: "14px",
                }}
              >
                Budget Head Details
              </label>

              <input
                type="text"
                placeholder="Enter Bugdet Head Details"
                style={{
                  border: "1px solid #dacccc",
                  borderRadius: "10px",
                  padding: "7px 10px",
                  width: "100%",
                  height: "40px",
                  boxSizing: "border-box",
                  fontSize: "12px",
                }}
                name="BudgetDetail"
                value={data.BudgetDetail}
                onChange={HandleChangeData}
                //required
              /> {errors.BudgetDetail && (
  <span
    style={{
      color: "#dc3545",
      fontSize: "12px",
      marginTop: "4px",
    }}
  >
    {errors.BudgetDetail}
  </span>
)}          </div>

            {/* CRC */}
            <div style={{ display: "flex", flexDirection: "column" }}>
              <label
                className="form-label"
                style={{
                  fontWeight: "700",
                  marginBottom: "6px",
                  fontSize: "14px",
                }}
              >
                CRC
              </label>

              <input
                type="text"
                placeholder="Enter CRC"
                className="form-control py-2"
                style={{
                  border: "1px solid #c7c0c0",
                  borderRadius: "10px",
                  padding: "7px 10px",
                  width: "100%",
                  height: "40px",
                  boxSizing: "border-box",
                  fontSize: "12px",
                }}
                name="CRC"
                value={data.CRC}
                onChange={HandleChangeData}
                //required
              /> {errors.CRC && (
  <span
    style={{
      color: "#dc3545",
      fontSize: "12px",
      marginTop: "4px",
    }}
  >
    {errors.CRC}
  </span>
)}
 
            </div>

         

            {/* GR Date */}
            <div style={{ display: "flex", flexDirection: "column" }}>
              <label
                className="form-label"
                style={{
                  fontWeight: "700",
                  marginBottom: "6px",
                  fontSize: "14px",
                }}
              >
                Budget GR Date
              </label>

{/* 24-10  change the calender*/}
       <div style={{ display: "flex", gap: "8px" }}>
  
<input
  type="datetime-local"
  className="form-control py-2"
  name="GRDate"
  value={(data.GRDate || "").slice(0, 16)}
  min={getCurrentDateTime()}
  max="9999-12-31T23:59"
  onChange={handleGRDateTimeChange}
  style={{
    width: "100%",
    height: "42px",
    borderRadius: "10px",
    border: "1px solid #c7c0c0",
    fontSize: "12px",
  }}
/>

</div>
           
 {errors.GRDate && (
  <span
    style={{
      color: "#dc3545",
      fontSize: "12px",
      marginTop: "4px",
    }}
  >
    {errors.GRDate}
  </span>
)}
     
            </div>

            {/* GR Copy */}
            <div style={{ display: "flex", flexDirection: "column" }}>
              <label
                className="form-label"
                style={{
                  fontWeight: "700",
                  marginBottom: "6px",
                  fontSize: "14px",
                }}
              >
                {" "}
                Budget GR Copy
              </label>
              <input
                type="file"
                className="form-control py-2"
                style={{
                  border: "1px solid #c7c0c0",
                  borderRadius: "10px",
                  padding: "7px 10px",
                  width: "100%",
                  height: "40px",
                  boxSizing: "border-box",
                  fontSize: "12px",
                }}
                id="GRCopy"
                // 16-10 for grcopy fetch
                onChange={(e) => {
    setNewGRFile(e.target.files[0] || null);
    setErrors((prev) => ({ ...prev, GRCopy: "" }));
  }}
                //required={!isEdit}
              />{errors.GRCopy && (
  <span
    style={{
      color: "#dc3545",
      fontSize: "12px",
      marginTop: "4px",
    }}
  >
    {errors.GRCopy}
  </span>
)}
 
         
{/* 16-10 for gr copy fetch */}
{isEdit && newGRFile && (
  <div style={{ marginTop: "8px", fontSize: "12px" }}>
    <span style={{ fontWeight: "600" }}>New GR Copy selected: </span>
    {newGRFile.name}
  </div>
)}

{isEdit && !newGRFile && data.GRCopy && typeof data.GRCopy === "string" && (
  <div style={{ marginTop: "8px", fontSize: "12px" }}>
    <span style={{ fontWeight: "600" }}>Existing GR Copy: </span>
    <a
      href={`${apiurl}/HeadDocsImages/${encodeURIComponent(data.GRCopy)}`}
      target="_blank"
      rel="noopener noreferrer"
      style={{ color: "#0066cc", textDecoration: "underline" }}
    >
      {data.GRCopy}
    </a>
  </div>
)}
            </div>
          </div>
          {/* Add button */}
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              gap: "15px",
              marginTop: "22px",
              width: "100%",
            }}
          >
            <button
             type="button"  //16-10
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                borderRadius: "5px",
                width: "100px",
                height: "40px",
                backgroundColor: "#2e9e4f",
                border: "none",
                fontSize: "11px",
                color: "#fff",
                fontWeight: "600",
                cursor: "pointer",
                // boxShadow:" box-shadow: rgba(0, 0, 0, 0.07) 0px 1px 2px, rgba(0, 0, 0, 0.07) 0px 2px 4px, rgba(0, 0, 0, 0.07) 0px 4px 8px, rgba(0, 0, 0, 0.07) 0px 8px 16px, rgba(0, 0, 0, 0.07) 0px 16px 32px, rgba(0, 0, 0, 0.07) 0px 32px 64px",
                boxShadow:
                  "rgba(0, 0, 0, 0.16) 0px 10px 36px 0px, rgba(0, 0, 0, 0.06) 0px 0px 0px 1px",
              }}
              onClick={isEdit ? handleUpdate : handleAddHead}
            >
              <img
                src={submit}
                style={{
                  marginRight: "10px",
                  width: "1.2rem",
                  paddingBottom: "3px",
                  fontSize: "15px",
                }}
              />
              {isEdit
                ? "Update"
                : editingIndex !== null
                  ? "Update Head"
                  : "Add Head"}
            </button>

            <button
              type="button"
             
              // 05-10
                onClick={handleCancel}
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                borderRadius: "5px",
                width: "100px",
                height: "40px",
                backgroundColor: "#f84b4b",
                border: "none",
                fontSize: "11px",
                color: "#fff",
                fontWeight: "600",
                cursor: "pointer",
                boxShadow:
                  " box-shadow: rgba(0, 0, 0, 0.07) 0px 1px 2px, rgba(0, 0, 0, 0.07) 0px 2px 4px, rgba(0, 0, 0, 0.07) 0px 4px 8px, rgba(0, 0, 0, 0.07) 0px 8px 16px, rgba(0, 0, 0, 0.07) 0px 16px 32px, rgba(0, 0, 0, 0.07) 0px 32px 64px",
              }}
            >
              <img
                src={Cancel32}
                style={{ marginRight: "10px", width: "1.2rem" }}
              />
              Cancel
            </button>
          </div>
        </div>
      </form>
      </div>

      {/* Show table of added heads */}
     

{headList.length > 0 && (
  <div className="budget-table-wrapper">
    <div className="budget-table-scroll">
      <table className="budget-head-table">
        <thead>
          <tr>
            <th>Sr. No.</th>
            <th>Budget Head</th>
            <th>Object Code</th>
            <th>Details</th>
            <th>CRC</th>
            <th>Action</th>
          </tr>
        </thead>

        <tbody>
          {headList.map((item, index) => (
            <tr key={index}>
              <td>{index + 1}</td>
              <td>{item.BudgetHeadName}</td>

              <td>
                {String(item.ObjectCode) === "0"
                  ? "NA"
                  : item.ObjectCode}
              </td>

              <td>{item.BudgetDetail}</td>
              <td>{item.CRC}</td>

              <td>
                <div className="budget-table-actions">
                  <button
                    type="button"
                    className="budget-edit-btn"
                    onClick={() => handleEditHead(index)}
                  >
                    <img
                      src={EditIcon}
                      alt="Edit"
                      width="15"
                      height="15"
                    />
                    Edit
                  </button>

                  <button
                    type="button"
                    className="budget-delete-btn"
                    onClick={() => handleDeleteHead(index)}
                  >
                    <img
                      src={DeleteIcon}
                      alt="Delete"
                      width="15"
                      height="15"
                    />
                    Delete
                  </button>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>

    <div style={{textAlign:"center",justifyContent:"center"}} className="budget-table-footer">
      <button
        type="button"
        className="budget-final-submit"
        onClick={handleFinalSubmit}
        disabled={loading}
      >
        <img src={submit} alt="" width="16" height="16" />
        {loading ? "Submitting..." : "Final Submit"}
      </button>
    </div>
  </div>
)}


    </div>
 
  );
};

export default BudgetHeadCreation;
